/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PriceBandRequest,
    PriceBandRequestFromJSON,
    PriceBandRequestFromJSONTyped,
    PriceBandRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface PriceBandRequestCriteriaRequest
 */
export interface PriceBandRequestCriteriaRequest {
    /**
     * 
     * @type {PriceBandRequest}
     * @memberof PriceBandRequestCriteriaRequest
     */
    value?: PriceBandRequest;
    /**
     * 
     * @type {boolean}
     * @memberof PriceBandRequestCriteriaRequest
     */
    exclude?: boolean;
}

export function PriceBandRequestCriteriaRequestFromJSON(json: any): PriceBandRequestCriteriaRequest {
    return PriceBandRequestCriteriaRequestFromJSONTyped(json, false);
}

export function PriceBandRequestCriteriaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceBandRequestCriteriaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : PriceBandRequestFromJSON(json['value']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function PriceBandRequestCriteriaRequestToJSON(value?: PriceBandRequestCriteriaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': PriceBandRequestToJSON(value.value),
        'exclude': value.exclude,
    };
}


